import { Menu } from "antd"
import { InboxOutlined } from "@ant-design/icons"
import Link from "next/link"
import ConfidentialityDisclaimer from "./confidentiality-disclaimer"
import PropTypes from "prop-types"

export const PaymentMenu = ({ step, submenu }) => {

  return (
    <>
      <Menu
        defaultSelectedKeys={[step]}
        defaultOpenKeys={[submenu]}
        theme="dark"
        className="fico main-menu"
        mode="inline">
        <Menu.Item icon={<InboxOutlined />} key="PAYMENT_DETAILS">
          <Link href={"/admin/projects/payments-details"}>
            Pagos
          </Link>
        </Menu.Item>
      </Menu>
      <ConfidentialityDisclaimer />
    </>
  )
}

PaymentMenu.propTypes = {
  step: PropTypes.string,
  submenu: PropTypes.string
}
